<template>
    <div class="contentWrapper">
        <div class="contentBlock">
            <div class="btn-group btn-group-justified">
                <div class="btn-group">
                    <button type="button" class="btn btn-vk" @click="NewTabUrlOpen($store.state.vkURL)"><span class="btn-icon"><i class="fab fa-vk"></i></span><span class="hidden-xs">{{$t('text.ButtonVk')}}</span></button>
                </div>

                <div class="btn-group">
                    <button type="button" class="btn btn-danger" @click="NewTabUrlOpen($store.state.youtubeURL)"><span class="btn-icon"><i class="fab fa-youtube"></i></span><span class="hidden-xs">{{$t('text.ButtonYoutube')}}</span></button>
                </div>
                <div class="btn-group">
                    <button type="button" class="btn btn-discord" @click="NewTabUrlOpen($store.state.discordURL)"><span class="btn-icon"><i class="fab fa-discord"></i></span><span class="hidden-xs">{{$t('text.ButtonDiscord')}}</span></button>
                </div>
            </div>
            <h3>{{$t('text.MPageTitle')}}</h3>
            <p>{{$t('text.MPage1')}}</p>

            <p>{{$t('text.MPage2')}}</p>
            <div class="well well-sm">
                <b>{{$t('text.MPageWarning')}}</b>
            </div>
			<p>{{$t('text.MPage3')}}</p>
            <div class="row">
                <div class="col-md-6">
                    <div class="panel panel-info">
                        <div class="panel-heading">
                            <h4 class="text-center">RENEWATION 0.7.8</h4>
                            {{$t('text.MPageForW4M')}}
                        </div>
                        <ul class="list-group list-group-flush text-center">
                            <li class="list-group-item li-compare" @click="GoContent('maps')"><span class="badge badge-maps"><i class="fas fa-globe"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('maps',1)}}</span>{{$t('text.CompareMaps')}}</li></router-link> 
                            <li class="list-group-item li-compare" @click="GoContent('clothes')"><span class="badge badge-clothes"><i class="fas fa-tshirt"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('clothes',1)}}</span>{{$t('text.CompareStuff')}}</li></router-link>
                            <li class="list-group-item li-compare" @click="GoContent('weapons')"><span class="badge badge-weapons"><i class="fas fa-crosshairs"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('weapons',1)}}</span>{{$t('text.CompareWeapons')}}</li></router-link>
                            <li class="list-group-item li-compare" @click="GoContent('skins')"><span class="badge badge-skins"><i class="fas fa-paint-brush"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('skins',1)}}</span>{{$t('text.CompareSkins')}}</li></router-link>
                            <li class="list-group-item li-compare" @click="GoContent('gamemodes')"><span class="badge badge-gameModes"><i class="fas fa-cog"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('gamemodes',1)}}</span>{{$t('text.CompareGameModes')}}</li></router-link>
                            <li class="list-group-item li-compare" @click="GoContent('missions')"><span class="badge badge-missions"><i class="fas fa-book-open"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('missions',1)}}</span>{{$t('text.CompareMissions')}}</li></router-link>
							<li class="list-group-item disabled" @click="GoContent('missions')"><b>{{$t('text.MPageW4MUpdate')}}</b></li>
                        </ul>
                        <div class="panel-footer">
                            <router-link :to="'/files/w4m'"><a class="btn btn-lg btn-block btn-info">{{$t('text.ButtonGetW4M')}}</a></router-link>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="panel panel-danger">
                        <div class="panel-heading">
                            <h4 class="text-center">RENEWATION HD 0.2A</h4>
                            {{$t('text.MPageForWUM')}}
                        </div>
                        <ul class="list-group list-group-flush text-center">
                            <li class="list-group-item li-compare" @click="GoContent('maps')"><span class="badge badge-maps"><i class="fas fa-globe"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('maps',2)}}</span>{{$t('text.CompareMaps')}}</li>
                            <li class="list-group-item li-compare" @click="GoContent('clothes')"><span class="badge badge-clothes"><i class="fas fa-tshirt"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('clothes',2)}}</span>{{$t('text.CompareStuff')}}</li>
                            <li class="list-group-item li-compare" @click="GoContent('weapons')"><span class="badge badge-weapons"><i class="fas fa-crosshairs"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('weapons',2)}}</span>{{$t('text.CompareWeapons')}}</li>
                            <li class="list-group-item li-compare" @click="GoContent('skins')"><span class="badge badge-skins"><i class="fas fa-paint-brush"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('skins',2)}}</span>{{$t('text.CompareSkins')}}</li>
                            <li class="list-group-item li-compare" @click="GoContent('gamemodes')"><span class="badge badge-gameModes"><i class="fas fa-cog"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('gamemodes',2)}}</span>{{$t('text.CompareGameModes')}}</li>
                            <li class="list-group-item li-compare" @click="GoContent('missions')"><span class="badge badge-missions"><i class="fas fa-book-open"></i>&nbsp;{{this.$store.getters.componentsByTypeCount('missions',2)}}</span>{{$t('text.CompareMissions')}}</li>
							<li class="list-group-item disabled" @click="GoContent('missions')"><b>{{$t('text.MPageWUMUpdate')}}</b></li>
                        </ul>
                        <div class="panel-footer">
                            <router-link :to="'/files/wum'"><a class="btn btn-lg btn-block btn-danger">{{$t('text.ButtonGetWUM')}}</a></router-link>
                        </div>
                    </div>
                </div>        
            </div>            
            <app-GalerySlider v-bind:galeryArray="this.galeryArray" galeryAlbum="mainpage"></app-GalerySlider>

        </div>
    </div>
</template>

<script>
export default {
    name: 'MainPage',
    data: () => ({
        // Default options for the carousel
        elemVisible: 3, // Кол-во отображаемых элементов в карусели
        loop: true,     // Бесконечное зацикливание карусели 
        auto: true,     // Автоматическая прокрутка
        interval: 5000, // Интервал между прокруткой элементов (мс)
        speed: 750,     // Скорость анимации (мс)
        touch: true,    // Прокрутка  прикосновением
        arrows: true,   // Прокрутка стрелками
        dots: true,      // Индикаторные точки
        galeryArray: ['001','002','003','004','005','006','007','008','009']
        
    }),
    methods: {
        NewTabUrlOpen(val){
            window.open(val, '_blank')
        },
		GoContent(val){
			this.$router.push('/content/'+val)
		},
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.li-compare {
		background-color: #ffffff;
		cursor: pointer;
	}
	.li-compare:hover {
		background-color: #eeeeee;
		cursor: pointer;
	}
	
    .btnDiscordLayout {
       margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue